import React, { FC, useMemo } from 'react';
import { ReactTable, CheckboxInput } from '@td-client-frontend/common';
import { ManageRoleType } from '../../@types/Roles';
import { useAuth } from '../../context/AuthContext';

interface ManageRolesTableProps {
  rolesData: ManageRoleType[];
  checkedRoles: string[];
  onMainCheck: () => void;
  onRoleManage: (roleId: string) => void;
  onRoleSelect: (checked: boolean, roleId: string) => void;
  isFetching: boolean;
}

const ManageRolesTable: FC<ManageRolesTableProps> = ({
  rolesData,
  onRoleManage,
  isFetching,
  checkedRoles,
  onMainCheck,
  onRoleSelect
}) => {
  const { checkPerm } = useAuth();
  const readOnly = !checkPerm('RoleWrite');
  const rolesColumns = useMemo(() => {
    const isAllRolesSelected: boolean = !!(rolesData.length && rolesData.length === checkedRoles.length);
    return [
      {
        id: 'mainCheckbox',
        Header: <CheckboxInput checked={isAllRolesSelected} onChange={onMainCheck} />,
        isVisible: !readOnly,
        width: '4',
        Cell: ({
          row: {
            original: { id }
          }
        }) => {
          const checked = checkedRoles.includes(id);
          return <CheckboxInput checked={checked} onChange={() => onRoleSelect(checked, id)} disabled={undefined} />;
        }
      },
      {
        Header: 'Role Name',
        accessor: 'roleNm'
      },
      {
        Header: 'Users',
        accessor: 'userCount',
        disableSortBy: true
      },
      {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        Cell: ({
          row: {
            original: { active }
          }
        }) => {
          return active ? <span>Active</span> : <span>Inactive</span>;
        }
      },
      {
        Header: 'Actions',
        id: 'actions',
        disableSortBy: true,
        isVisible: checkPerm('RoleWrite') || checkPerm('RoleRead'),
        Cell: ({
          row: {
            original: { id }
          }
        }) => {
          return (
            <button className="flex text-primary-500 hover:text-primary-70" onClick={() => onRoleManage(id)}>
              {readOnly ? 'View' : 'Manage'}
            </button>
          );
        }
      }
    ];
  }, [checkPerm, checkedRoles, onMainCheck, onRoleManage, onRoleSelect, rolesData.length, readOnly]);
  return <ReactTable data={rolesData} columns={rolesColumns} isFetching={isFetching} getSortBy manualSortBy />;
};

export default ManageRolesTable;
